<!-- @format -->

<company-detail>
  <dl class="description_list">
    <template each="{ data in state.list }" if="{ data.text != '' }">
      <dt class="description_list-term">{ data.label }：</dt>
      <dd
        class="description_list-definition { data.updated ? 'description_list-changes' :'' }"
      >
        <template if="{ data.label !== '事業内容' }">{ data.text }</template>
        <template
          if="{ data.label === '事業内容' && typeof data.text === 'string' }"
        >
          <div each="{ text in data.text.split('\n') }">{ text }</div>
        </template>
      </dd>
    </template>
  </dl>

  <!--/.application_form-->
  <script>
    export default {
      state: { list: [] },
      onBeforeMount(props, state) {
        this.shouldUpdate(props, props);
      },
      shouldUpdate(newProps, currentProps) {
        const list = this.dataList(newProps.data);
        if (newProps.before) {
          this.dataList(newProps.before).forEach(
            (e, i) => (list[i].updated = list[i].text !== e.text)
          );
        }
        this.state.list = list;
      },
      dataList(data) {
        const nc = (e) => (e ? e : "");
        const pref = this.props.prefs.find((e) => e.id == data.pref);
        const address = `${nc(data.zip)} ${pref ? pref.jname : ""} ${nc(
          data.address1
        )} ${nc(data.address2)}`;
        return [
          { label: "会社名", text: nc(data.company_name) },
          { label: "会社名(かな)", text: nc(data.company_kana) },
          { label: "代表者氏名", text: nc(data.representative) },
          {
            label: "本社所在地",
            text: address == "   " ? "" : address,
          },
          { label: "ホームページアドレス", text: nc(data.url) },
          { label: "電話番号", text: nc(data.tel) },
          { label: "事業内容", text: nc(data.content) },
          {
            label: "設立",
            text:
              data.established_year && data.established_month
                ? `${data.established_year}年${data.established_month}月`
                : "",
          },
          { label: "資本金", text: nc(data.capital) },
          { label: "上場", text: `${nc(["非上場", "上場"][data.listed])}` },
          { label: "法人番号", text: nc(data.code) },
        ];
      },
    };
  </script>
</company-detail>
